import { render, staticRenderFns } from "./PosTipDeclaration.vue?vue&type=template&id=7a892e37&scoped=true"
import script from "./PosTipDeclaration.vue?vue&type=script&lang=js"
export * from "./PosTipDeclaration.vue?vue&type=script&lang=js"
import style0 from "./PosTipDeclaration.vue?vue&type=style&index=0&id=7a892e37&prod&lang=scss&scoped=true"
import style1 from "./PosTipDeclaration.vue?vue&type=style&index=1&id=7a892e37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a892e37",
  null
  
)

export default component.exports